export default {
  "calendar.weekday": "曜日",
  "calendar.sun": "日",
  "calendar.mon": "月",
  "calendar.tue": "火",
  "calendar.wed": "水",
  "calendar.thu": "木",
  "calendar.fri": "金",
  "calendar.sat": "土",
  "calendar.week": "週",
  "calendar.day": "日",
  "calendar.month": "月",
  "calendar.year": "年",
  "calendar.weekly": "每週",
  "calendar.monthly": "毎月",
  "calendar.inputPlaceholder": "日付を選択してください",
  "calendar.hour": "時",
  "calendar.min": "分",
  "calendar.sec": "秒",
};